var _path, _ellipse, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightImgPinNotpartner56 = function SvgLightImgPinNotpartner56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 0h56v56H3z",
    opacity: 0.01
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 43,
    fill: "#000",
    opacity: 0.2,
    rx: 6,
    ry: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#light_img_pin_notpartner_56_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.01,
    fillRule: "evenodd",
    d: "M16.158 13.111c-6.122 0-11.084 4.962-11.084 11.083s4.962 11.084 11.083 11.084h9.846l3.112 4.977a1 1 0 0 0 1.696 0l3.112-4.977h9.846c6.12 0 11.083-4.962 11.083-11.084 0-6.12-4.962-11.083-11.083-11.083z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16 11C9.373 11 4 16.373 4 23s5.373 12 12 12h9.96l4.192 6.706a1 1 0 0 0 1.696 0L36.04 35H46c6.627 0 12-5.373 12-12s-5.373-12-12-12z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#60717C",
    d: "m25.96 35 .423-.265a.5.5 0 0 0-.424-.235zm4.192 6.706.424-.265zm1.696 0 .424.265zM36.04 35v-.5a.5.5 0 0 0-.424.235zM4.5 23c0-6.351 5.149-11.5 11.5-11.5v-1C9.096 10.5 3.5 16.096 3.5 23zM16 34.5C9.649 34.5 4.5 29.351 4.5 23h-1c0 6.904 5.596 12.5 12.5 12.5zm9.96 0H16v1h9.96zm4.616 6.941-4.193-6.706-.848.53 4.193 6.706zm.848 0a.5.5 0 0 1-.848 0l-.848.53a1.5 1.5 0 0 0 2.544 0zm4.193-6.706-4.193 6.706.848.53 4.193-6.706zM46 34.5h-9.96v1H46zM57.5 23c0 6.351-5.149 11.5-11.5 11.5v1c6.904 0 12.5-5.596 12.5-12.5zM46 11.5c6.351 0 11.5 5.149 11.5 11.5h1c0-6.904-5.596-12.5-12.5-12.5zm-30 0h30v-1H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#60717C",
    fillRule: "evenodd",
    d: "M37.667 22.141v1.36h-1.392l-1.294 5.03h-1.504l-1.327-5.03h-1.504c-.42 1.633-.906 3.38-1.343 5.03h-1.52l-1.279-5.03H25v-1.36h1.18c-.323-1.31-.662-2.847-.97-4.141H26.7l.954 4.141h1.893L30.565 18h1.634l1.019 4.141h1.909c.323-1.326.647-2.814.97-4.141h1.505l-1.003 4.141zm-3.462 3.77.598-2.41H33.59c.21.873.372 1.487.615 2.41m-5.646-.017.647-2.394h-1.23zm2.426-3.753h.826c-.162-.614-.243-.873-.421-1.569-.13.534-.275 1.003-.405 1.57",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "light_img_pin_notpartner_56_svg__a",
    width: 59.777,
    height: 37.614,
    x: 0.074,
    y: 10.111,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.313151 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_115_987",
    result: "shape"
  })))));
};
export default SvgLightImgPinNotpartner56;